import styled from "styled-components"

import tokens from "../_tokens"

const Blockquote = styled.blockquote`
  margin: 0 0 ${1.5 * tokens.size.base}px;
  padding: 0 ${1.5 * tokens.size.base}px;
  color: ${tokens.color.text.muted};
  border-left: 0.25em solid ${tokens.color.bgLight};

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
`

export default Blockquote
